import { useEffect, useMemo, useRef, useState } from "react";
import { api } from "../lib/api";

// Searchable multi-select over the generator's biome table. The list comes
// from the server (which gets it from the C++ biome table), so it can never
// drift from what the generator actually knows.

export function BiomePicker(props: {
  value: number[];
  onChange: (ids: number[]) => void;
}) {
  const [all, setAll] = useState<
    { id: number; name: string; label: string }[]
  >([]);
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const box = useRef<HTMLLabelElement>(null);

  useEffect(() => {
    api.biomes().then(setAll).catch(() => setAll([]));
  }, []);

  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => {
      if (box.current && !box.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  const shown = useMemo(() => {
    const needle = q.trim().toLowerCase();
    return needle
      ? all.filter((b) => b.label.toLowerCase().includes(needle))
      : all;
  }, [all, q]);

  const chosen = new Set(props.value);
  const toggle = (id: number) => {
    const next = new Set(chosen);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    props.onChange([...next].sort((a, b) => a - b));
  };

  return (
    <label className="biomes" ref={box}>
      Biome
      <button type="button" onClick={() => setOpen((o) => !o)}>
        {props.value.length === 0
          ? "alle Biome"
          : `${props.value.length} Biom${props.value.length === 1 ? "" : "e"}`}
      </button>
      {open && (
        <div className="popover">
          <input
            autoFocus
            placeholder="Biom suchen…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
          <div className="bulk">
            <button type="button" onClick={() => props.onChange(shown.map((b) => b.id))}>
              angezeigte wählen
            </button>
            <button type="button" onClick={() => props.onChange([])}>
              zurücksetzen
            </button>
          </div>
          <div className="list">
            {shown.map((b) => (
              <label key={b.id}>
                <input
                  type="checkbox"
                  checked={chosen.has(b.id)}
                  onChange={() => toggle(b.id)}
                />
                {b.label}
              </label>
            ))}
            {all.length === 0 && <p className="hint">Biomliste nicht verfügbar</p>}
          </div>
        </div>
      )}
    </label>
  );
}
